const VERSION = '1.0.7';

export default  VERSION 